import React, { useEffect } from 'react'
import PinInput from '../components/PinInput'
import { useNavigate, useParams } from 'react-router-dom';
import CustomLoader from '../components/Loader';

function Login() {

    const {vendorId}= useParams()
    const [vendorName, setVendorName]= React.useState();
    const [isLoading, setIsLoading]= React.useState(true);
    const navigate = useNavigate();

    useEffect(()=>{
        getVendor();
    },[vendorId])

    async function getVendor(){
        try {
            setIsLoading(true)
            const URL= "/server/fodder_portal_access_free_function/vendor?vendorId="+vendorId;
            const res= await fetch(URL, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            const data= await res.json()
            
            if(!data.success || data.msg) navigate("/error",{state: {error: "Incorrect Vendor Id: Vendor doesn't exists!"}});
            setVendorName(data.res)
        } catch (error) {
            console.log(error.message)
        }finally{
            setIsLoading(false)
        }
    }

    return (
        <>
            <div className='w-screen h-screen flex flex-col items-center justify-center bg-gray-200 login-bg '>
                {
                    isLoading?
                    <CustomLoader size={10} color={"#000000"}/>
                    :
                    <div className='bg-white px-10 sm:px-20 py-16 rounded-lg shadow-md space-y-14 w-[90%] max-w-[500px] flex flex-col justify-center mb-24 md:mb-0'>
                        <img src="https://fodderlink.com.au/wp-content/uploads/2021/07/fodder-logo.png" alt="" className='max-h-14'/>
                        <div className='text-center space-y-2'>
                            <div className='text-2xl font-semibold'>Creditor Dashboard</div>
                            <div className='text-xl font-semibold text-foreground-muted'>Hey{vendorName?", "+vendorName:""} 👋🏻</div>
                        </div>
                        <div className='text-center space-y-4 max-w-full'>
                            <div className='text-md text-foreground-muted'>Enter PIN sent via SMS</div>
                            <PinInput/>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default Login